module.exports = __webpack_public_path__ + "static/media/ISCI_SCS1.748fb898.jpg";